import React from 'react';
import callApi from '../../utils/callApi';
import { NEW_PASSWORD_URL } from '../../constants/apiUrls/apiUrls';

class NewPasswordPage extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(this.props.location.search);
        const username = params.get('username');
        const email = params.get('email');

        this.state = {
            username,
            email,
            password: '',
            confirmPassword: '',
            matchError: false
        };
    }
    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
            matchError: false
        });
    };
    handleSubmit = e => {
        const { password, confirmPassword } = this.state;
        e.preventDefault();
        const trimmedPassword = password && password.trim();
        const trimmedConfirmPassword = confirmPassword && confirmPassword.trim();

        if (trimmedPassword && trimmedPassword === trimmedConfirmPassword) {
            callApi(
                NEW_PASSWORD_URL.replace(
                    '{token}',
                    this.props.match.params.token
                ),
                'POST',
                false,
                `password=${encodeURIComponent(trimmedPassword)}`,
                {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            )
                .then(res => {
                    if (res.status === 200) {
                        this.props.history.push('/account/login');
                    }
                })
                .catch(err => console.log(err));
        } else {
            // show error
            this.setState({
                matchError: true
            });
        }
    };
    render() {
        const { password, confirmPassword, matchError } = this.state;
        return (
            <div className="content">
                <div className="container">
                    <div className="row-r">
                        <div className="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
                            <div className="nakednews-form-container new-password-form">
                                <div className="nakednews-form-title">
                                    Enter new password
                                </div>
                                <div className="nakednews-form">
                                    {matchError && (
                                        <div
                                            className="nakednews-form-error"
                                            style={{ bottom: '-10px' }}
                                        >
                                            Passwords must match
                                        </div>
                                    )}
                                    <div className="nakednews-form-error" />
                                    <div className="nakednews-form-text">
                                        Please enter new password
                                    </div>
                                    <form
                                        noValidate="novalidate"
                                        className="formtastic form-horizontal password"
                                        acceptCharset="UTF-8"
                                        onSubmit={this.handleSubmit}
                                    >
                                        <div
                                            className="string input required stringish form-group"
                                            id="username_input"
                                            style={{display: 'none'}}
                                        >
                                            <div className="col-lg-9">
                                                <input
                                                    className="form-input username"
                                                    placeholder="Username"
                                                    id="new_username"
                                                    name="newUsername"
                                                    type="text"
                                                    value={this.state.email}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="string input required stringish form-group"
                                            id="password_input"
                                        >
                                            <div className="col-lg-9">
                                                <input
                                                    className="form-input password"
                                                    placeholder="Password"
                                                    id="new_password"
                                                    name="newPassword"
                                                    type="password"
                                                    value={password}
                                                    onChange={this.handleChange(
                                                        'password'
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="string input required stringish form-group"
                                            id="new_password_input"
                                        >
                                            <div className="col-lg-9">
                                                <div className="nakednews-form-text">
                                                    Confirm password
                                                </div>
                                                <input
                                                    className="form-input password"
                                                    placeholder="Password"
                                                    id="confirm_password"
                                                    name="confirmPassword"
                                                    type="password"
                                                    value={confirmPassword}
                                                    onChange={this.handleChange(
                                                        'confirmPassword'
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-lg-offset-3 col-lg-9">
                                                <button
                                                    name="button"
                                                    type="submit"
                                                    className="btn btn-black action-button"
                                                    id="password_submit_action"
                                                >
                                                    Save new password
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewPasswordPage;
